import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

export const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isValidating } = useContext(AuthContext);

  if (isValidating) {
    return <div style={{ padding: "2rem", textAlign: "center" }}>Verificando sesión...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export const RoleProtectedRoute = ({ children, allowedRoles }) => {
  const { user, isAuthenticated, isValidating } = useContext(AuthContext);

  if (isValidating) {
    return <div style={{ padding: "2rem", textAlign: "center" }}>Verificando sesión...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!allowedRoles.includes(user?.role?.name)) {
    return <Navigate to="/" replace />;
  }

  return children;
};
